export const newsList = [
  {
    id: 'news-001',
    title: '《善良的女秘书》收官在即，林知夏的成长线为何打动观众',
    category: '剧透解析',
    date: '2025-10-12',
    summary:
      '随着《善良的女秘书》步入尾声，女主角林知夏从职场新人到独当一面的蜕变引发热议。本文试着拆解这条成长线背后的叙事逻辑与情感支点。',
    content: [
      '作为今年最受关注的都市职场剧之一，《善良的女秘书》用一个相对克制的视角，讲述了一个关于"善意如何被坚守"的故事。女主角林知夏并不是传统意义上的完美职场精英，她会犯错，会犹豫，也会在复杂的办公室关系中感到无力。',
      '恰恰是这种真实，让她的成长有了落地的重量。编剧没有给她开金手指，而是让她在一次次的挫折与选择中慢慢站稳脚跟。当她终于能够坦然地说出"我可以"的时候，观众感受到的是共情，而不是爽感。',
      '有评论认为，这条成长线的动人之处在于，它始终没有把"善良"简单化为软弱，也没有把它神化为无所不能。善良在林知夏身上，是一种明知艰难仍愿意选择的能力，这也是剧集最想传递的价值。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20entertainment%20news%20image%20of%20a%20film%20set%20with%20warm%20red%20lighting%20and%20an%20office%20desk%2C%20soft%20depth%20of%20field%2C%20clean%20minimal%20background%2C%20magazine%20photography%20style%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-001&orientation=landscape',
    author: '编辑部 · 顾言',
    views: 12840,
  },
  {
    id: 'news-002',
    title: '国产悬疑剧再出爆款，《暗夜追凶》凭什么口碑走高',
    category: '行业动态',
    date: '2025-10-08',
    summary:
      '上线两周，豆瓣评分稳定在8.6，播放量持续攀升。《暗夜追凶》的走红，或许再次印证了观众对扎实剧本的渴望。',
    content: [
      '在过去几年里，悬疑剧几乎成了国剧市场最拥挤的赛道。如何在同质化的环境中突围，《暗夜追凶》给出了一份颇具说服力的答案：把故事讲圆，把人物立住。',
      '该剧没有过度依赖视觉奇观和高能反转，而是把重心放在案件背后的动机与人性上。刑警高寒川与法医林见鹿的搭档关系，也并非简单的"宿敌式"人设，而是在一次次并肩中逐渐积累出可信的信任。',
      '有业内人士指出，观众审美正在快速成熟，真正能留住人的，始终是经得起推敲的故事。这或许也是悬疑剧创作回归理性的一个信号。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20moody%20atmosphere%20and%20warm%20red%20accent%20light%2C%20cinematic%20editorial%20photography%2C%20minimal%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-002&orientation=landscape',
    author: '行业观察 · 唐郁',
    views: 9640,
  },
  {
    id: 'news-003',
    title: '从《深巷暖阳》看年代剧的烟火气表达',
    category: '影视评论',
    date: '2025-09-30',
    summary:
      '没有强情节，没有大场面，《深巷暖阳》却凭一巷子的家长里短收获高口碑。年代剧的"烟火气"到底该怎么拍？',
    content: [
      '年代剧最怕的是"假"，假布景、假方言、假情感。而《深巷暖阳》最打动人的，恰恰是它把镜头对准了那些再普通不过的日常：一碗热汤，一句唠叨，一个傍晚巷口亮起的灯。',
      '剧中的邻里关系既亲密又克制，有摩擦也有扶持，这种尺度拿捏得相当准确。它没有刻意煽情，却总能在不经意处让人眼眶一热。',
      '所谓烟火气，说到底是对生活的尊重。当创作者愿意慢下来，去看一看普通人是如何度过他们的一天，年代剧才真正有了温度。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20golden%20afternoon%20sunlight%20in%20an%20old%20Chinese%20alley%20with%20red%20lanterns%2C%20nostalgic%20editorial%20photography%2C%20minimal%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-003&orientation=landscape',
    author: '影评专栏 · 何砚',
    views: 7210,
  },
  {
    id: 'news-004',
    title: '十月剧集市场前瞻：多部重磅新剧集中开播',
    category: '行业动态',
    date: '2025-09-26',
    summary:
      '进入十月，多部备受期待的剧集将陆续与观众见面，涵盖都市、悬疑、古装等多个类型，市场竞争愈发激烈。',
    content: [
      '据各平台公布的片单显示，十月将迎来一轮密集的新剧上线。既有《善良的女秘书》这样处于收官阶段的口碑剧，也有多部全新开播的作品同台竞技。',
      '从类型分布看，都市情感与悬疑刑侦依然是两大主力，古装剧的占比则较去年同期有所回升。业内普遍认为，题材的多元化对观众而言是件好事。',
      '值得注意的是，短剧集模式正被越来越多作品采用。更紧凑的叙事节奏能否成为国产剧新的常态，值得持续关注。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20display%20screens%20glowing%20with%20warm%20red%20and%20amber%20tones%2C%20clean%20minimal%20editorial%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-004&orientation=landscape',
    author: '编辑部 · 周叙',
    views: 6380,
  },
  {
    id: 'news-005',
    title: '专访《善良的女秘书》导演陆为安：我想拍一个温柔的职场',
    category: '幕后花絮',
    date: '2025-09-20',
    summary:
      '在采访中，导演陆为安聊到了创作的初衷、对"善良"的理解，以及剧集在细节打磨上的种种考量。',
    content: [
      '"我不想再拍一个勾心斗角的故事了。"陆为安在采访一开始就这样说。在他看来，职场剧不一定要靠制造对立来吸引观众，温柔同样可以是一种力量。',
      '为了还原真实的职场质感，剧组在开拍前做了大量的实地调研，甚至邀请了几位真实的资深秘书担任顾问。片中不少细节，都是从她们的工作日常中提炼而来。',
      '谈到外界对"善良"的讨论，陆为安显得很平静："善良不是没有边界，而是清楚自己的边界之后，依然选择体面。这是我想通过林知夏传达的东西。"',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20film%20director%20interview%20scene%20in%20a%20studio%20with%20soft%20red%20lighting%20and%20a%20chair%2C%20clean%20minimal%20editorial%20background%2C%20magazine%20photography%20style%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-005&orientation=landscape',
    author: '人物专访 · 苏晴',
    views: 8940,
  },
  {
    id: 'news-006',
    title: '演员阵容深度解析：《山海之约》为何选他们',
    category: '明星资讯',
    date: '2025-09-14',
    summary:
      '一部剧的成功，选角往往至关重要。《山海之约》的演员组合为什么能让观众"入戏"？聊聊背后的选角思路。',
    content: [
      '《山海之约》公布的演员名单一度引发讨论。几位主演并非当下最具流量的名字，却都具备扎实的表演功底，这与剧集本身"克制、细腻"的气质高度契合。',
      '据制作方透露，选角过程中最重要的标准是"像不像"。演员与角色之间那种难以言说的贴合感，是任何技巧都无法替代的。',
      '事实证明，这份坚持是值得的。剧集播出后，主演之间自然的化学反应成为观众讨论最多的话题之一。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20theater%20stage%20with%20soft%20warm%20red%20spotlight%20and%20velvet%20seats%2C%20minimal%20atmospheric%20editorial%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-006&orientation=landscape',
    author: '娱乐前线 · 林可',
    views: 7560,
  },
  {
    id: 'news-007',
    title: '古装武侠的新表达：《锦衣少年行》的江湖美学',
    category: '影视评论',
    date: '2025-09-08',
    summary:
      '从服化道到打戏设计，《锦衣少年行》试图用一种更写意的方式重建"江湖"。它做到了吗？',
    content: [
      '武侠题材在近些年并不算热门，但《锦衣少年行》的出现，让人重新看到了这一类型的可能性。剧集没有一味追求宏大场面的堆砌，而是把功夫放在了氛围的营造上。',
      '大量自然光的运用、留白式的构图，以及克制而有力的打戏设计，共同构成了一种颇具东方韵味的视觉语言。这样的江湖，安静却并不单薄。',
      '当然，剧集在节奏把控上仍有可商榷之处。但至少它证明了一点：传统类型并非没有观众，只是需要找到与当代审美对话的方式。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20in%20warm%20golden%20light%20with%20drifting%20mist%20and%20red%20silk%2C%20atmospheric%20cinematic%20editorial%20photography%2C%20minimal%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-007&orientation=landscape',
    author: '影评专栏 · 何砚',
    views: 6120,
  },
  {
    id: 'news-008',
    title: '现实主义题材回温：观众为什么越来越爱"接地气"的故事',
    category: '行业动态',
    date: '2025-08-30',
    summary:
      '从《归途》到《尘埃里开花》，现实主义作品的持续走红，折射出观众审美与市场需求的深层变化。',
    content: [
      '过去，现实主义题材常被认为"不够好看"。但近两年的市场表现却显示，越来越多的观众愿意为真实买单。',
      '这背后，既有观众审美成熟的因素，也与创作水准的整体提升有关。当创作者愿意沉下心去体验生活，故事自然就有了质感。',
      '有观点认为，现实主义不是简单地"写苦"，而是要写人在困境中的选择与尊严。这正是那些优秀作品真正打动人心的地方。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Documentary%20style%20image%20of%20ordinary%20people%20walking%20on%20a%20city%20street%20at%20golden%20hour%2C%20warm%20natural%20tones%2C%20minimal%20editorial%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-008&orientation=landscape',
    author: '行业观察 · 唐郁',
    views: 5740,
  },
  {
    id: 'news-009',
    title: '《长夜将尽》点映口碑出炉，被赞"年度最难忘的结局"',
    category: '剧透解析',
    date: '2025-08-22',
    summary:
      '影片尚未正式上映，超前点映场已经收获了大量好评，其中关于结尾的讨论尤其热烈。（本文含轻微剧透）',
    content: [
      '《长夜将尽》在几场超前点映后，迅速在社交平台引发讨论。观众普遍认为，影片对"告别"这一主题的处理克制而有力。',
      '有观众表示，最后的那个长镜头几乎让人无法呼吸。它没有给出一个明确的答案，却让所有的情绪都找到了落点。',
      '当然，也有声音认为影片的节奏偏慢。但对于一部关于时间与救赎的作品而言，这种缓慢或许正是它的一部分。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20dark%20blue%20dawn%20horizon%20with%20a%20lone%20silhouette%2C%20dramatic%20warm%20red%20rim%20light%2C%20minimal%20atmospheric%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-009&orientation=landscape',
    author: '观影指南 · 沈砚',
    views: 6810,
  },
  {
    id: 'news-010',
    title: '影视行业的"她叙事"：女性题材为何成为新风口',
    category: '明星资讯',
    date: '2025-08-15',
    summary:
      '女性题材作品的持续涌现，不仅是市场的选择，也反映了社会议题的变迁。',
    content: [
      '近几年，以女性成长、女性关系为核心的影视作品数量显著增加，且往往能收获不俗的口碑与热度。',
      '这类作品的魅力，在于它们往往能提供一种不同于传统叙事的视角。当镜头真正对准女性的内心与处境，故事便有了更丰富的层次。',
      '当然，"她叙事"不该被简单地理解为一个标签。真正优秀的作品，关注的始终是具体的人，而不是抽象的议题。',
    ],
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20modern%20woman%20silhouette%20against%20warm%20red%20soft%20light%2C%20minimal%20editorial%20photography%2C%20clean%20background%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=news-010&orientation=landscape',
    author: '娱乐前线 · 林可',
    views: 5320,
  },
];